import { isGlobalworth, paths } from 'config'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import PersistentSnackbar from 'shared/components/PersistentSnackbar'
import { usePasswordPolicyWarning } from './PasswordPolicyContext'

const PasswordPolicySnackbar = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const { visible, hidePasswordPolicyWarning } = usePasswordPolicyWarning()

  return (
    <PersistentSnackbar
      stacked
      severity="error"
      variant="filled"
      alertBackgroundColor={isGlobalworth ? '#c46309' : undefined}
      open={visible && location.pathname !== paths.security}
      message={t('passwordSafetyWarning')}
      actionLabel={t('changePassword')}
      onAction={() => history.push(paths.security)}
      actionButtonProps={{
        size: 'small',
        color: 'inherit',
      }}
      onClose={hidePasswordPolicyWarning}
    />
  )
}

export default PasswordPolicySnackbar
